import { MessageMedium } from 'constants/messageMediums';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';

export const MessageTypeHeaderText = 'Message Type frequency';

export const createMessageTypeSecondaryText = (messageMedium: MessageMedium) =>
  `Set a cap at the individual message type level. This will override the ${lowerCaseMessageMedium(
    messageMedium,
  )} frequency setting.`;
